import React from "react";
/* eslint-disable */
import {
    Box,
    TableBody, TableCell, TableContainer, TableHead, TableRow, Table,
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {

    render() {
        const grnData = this.props.grnList;
        const totalValues = this.props.totalValues;
        return (
            <div>
                <br />
                <br />
                <h3><center><u>Pending Package Details Report</u></center></h3>
                <div>&nbsp;</div>
                <div>&nbsp;</div>
                <Box minWidth={1050}>
                    <TableContainer style={{ marginLeft: '5px' }}>
                        <Table aria-label="caption table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">Fresh Collection Center</TableCell>
                                    <TableCell align="left">Date</TableCell>
                                    <TableCell align="left">Supplier Code</TableCell>
                                    <TableCell align="left">Supplier Name</TableCell>
                                    <TableCell align="left">SKU Name</TableCell>
                                    <TableCell align="left">SKU Code</TableCell>
                                    <TableCell align="right">Gross Amount</TableCell>
                                    <TableCell align="right">Deduction</TableCell>
                                    <TableCell align="right">Net Amount</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {grnData.map((data, index) => (
                                    <TableRow key={index}>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.freshCollectionCenter == null ? '-' : data.freshCollectionCenter}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {new Date(data.fromDate).toLocaleDateString()}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.supplierCode == null ? '-' : data.supplierCode}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.supplierName == null ? '-' : data.supplierName}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.skuName == null ? '-' : data.skuName}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.skuCode == null ? '-' : data.skuCode}
                                        </TableCell>
                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.grossAmount == null ? '-' : parseFloat(data.grossAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </TableCell>
                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.deduction == null ? '-' : parseFloat(data.deduction).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </TableCell>
                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.netAmount == null ? '-' : parseFloat(data.netAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <TableRow>
                                <TableCell align="left" colSpan={6} style={{ fontWeight: "bold" }}>Total</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>{totalValues.totalGross == null ? '-' : parseFloat(totalValues.totalGross).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>{totalValues.totalDeduction == null ? '-' : parseFloat(totalValues.totalDeduction).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>{totalValues.totalNet == null ? '-' : parseFloat(totalValues.totalNet).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                            </TableRow>
                        </Table>
                    </TableContainer>
                </Box>
            </div>
        );
    }
}
